import { reflectKeys } from "@helpers"
import { PRACTICE_PREFIX } from "./practice-prefix"

export const {
    PRACTICE_ERROR,
    PRACTICE_REQUEST,
    QUIZZES_SUCCESS,
    SET_VIEWED_QUIZ,
    LESSON_SUCCESS,
    SET_PRACTICE,
    TOGGLE_AUTH
} = reflectKeys(
    [
        "PRACTICE_ERROR",
        "PRACTICE_REQUEST",
        "QUIZZES_SUCCESS",
        "SET_VIEWED_QUIZ",
        "LESSON_SUCCESS",
        "SET_PRACTICE",
        "TOGGLE_AUTH"
    ],
    PRACTICE_PREFIX
)

export default {
    [PRACTICE_ERROR](state, payload) {
        state.practiceError = payload
        state.practiceLoading = false
    },
    [PRACTICE_REQUEST](state) {
        state.practiceError = null
        state.practiceLoading = true
    },
    [QUIZZES_SUCCESS](state, payload) {
        state.quizzes = payload
        state.practiceLoading = false
    },
    [SET_VIEWED_QUIZ](state, payload) {
        state.viewedQuiz = payload
    },
    [LESSON_SUCCESS](state, payload) {
        state.lesson = payload
        state.practiceLoading = false
    },
    [SET_PRACTICE](state, payload) {
        state.practice = payload
    },
    [TOGGLE_AUTH](state, payload) {
        state.isAuth = payload
    }
}
